import { jsx as _jsx } from "react/jsx-runtime";
import { SidebarProvider } from '@ui/contexts';
import AppLayoutContent from './AppLayoutContent';
const AppLayout = ({ onSearch }) => {
    return (_jsx(SidebarProvider, { onSearch: onSearch, children: _jsx(AppLayoutContent, {}) }));
};
export default AppLayout;
